define(['exports', 'react', 'classnames', 'pluralize', 'moment', '../../i18n', '../utils', '../../assets/carat-icon.svg', '../../assets/meter-carat.svg', '../../assets/Timer.svg', './SexyGauge', './styles/CandidateReportsView.css'], function (exports, _react, _classnames, _pluralize, _moment, _i18n, _utils, _caratIcon, _meterCarat, _Timer, _SexyGauge) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _classnames2 = _interopRequireDefault(_classnames);

	var _pluralize2 = _interopRequireDefault(_pluralize);

	var _moment2 = _interopRequireDefault(_moment);

	var _i18n2 = _interopRequireDefault(_i18n);

	var _caratIcon2 = _interopRequireDefault(_caratIcon);

	var _meterCarat2 = _interopRequireDefault(_meterCarat);

	var _Timer2 = _interopRequireDefault(_Timer);

	var _SexyGauge2 = _interopRequireDefault(_SexyGauge);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var SessionDetails = function (_Component) {
		_inherits(SessionDetails, _Component);

		function SessionDetails() {
			_classCallCheck(this, SessionDetails);

			return _possibleConstructorReturn(this, (SessionDetails.__proto__ || Object.getPrototypeOf(SessionDetails)).apply(this, arguments));
		}

		_createClass(SessionDetails, [{
			key: 'renderSessionName',
			value: function renderSessionName(name) {
				return _react2.default.createElement(
					'div',
					{ className: 'col-7' },
					_react2.default.createElement(
						'div',
						{ className: 'field-name-secondary' },
						_i18n2.default.t('dk-ui-lib.reports.session_name')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mt1 field-value normal-letter-spacing' },
						name.toUpperCase()
					)
				);
			}
		}, {
			key: 'renderSessionData',
			value: function renderSessionData(date) {
				return _react2.default.createElement(
					'div',
					{ className: 'col-2' },
					_react2.default.createElement(
						'div',
						{ className: 'field-name-secondary' },
						_i18n2.default.t('dk-ui-lib.date')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mt1 field-value' },
						date
					)
				);
			}
		}, {
			key: 'renderSessionTime',
			value: function renderSessionTime(time) {
				return _react2.default.createElement(
					'div',
					{ className: 'col-2' },
					_react2.default.createElement(
						'div',
						{ className: 'field-name-secondary' },
						_i18n2.default.t('dk-ui-lib.time')
					),
					_react2.default.createElement(
						'div',
						{ className: 'mt1 black field-value' },
						time
					)
				);
			}
		}, {
			key: 'renderTitleBar',
			value: function renderTitleBar() {
				var _props = this.props,
				    sessionName = _props.sessionName,
				    startedAt = _props.startedAt;

				return _react2.default.createElement(
					'div',
					{ className: 'border-bottom pb3' },
					_react2.default.createElement(
						'div',
						{ className: 'col-12 main-heading nunito-font py3' },
						_i18n2.default.t('dk-ui-lib.reports.session_details')
					),
					_react2.default.createElement(
						'div',
						{ className: 'flex justify-between' },
						this.renderSessionName(sessionName),
						this.renderSessionData(_moment2.default.unix(startedAt / 1000).format('DD MMM YYYY')),
						this.renderSessionTime(_moment2.default.unix(startedAt / 1000).format('h:mm A'))
					)
				);
			}
		}, {
			key: 'renderCaratScore',
			value: function renderCaratScore(score, label) {
				return _react2.default.createElement(
					'div',
					{ className: 'flex items-center' },
					_react2.default.createElement(
						'div',
						{ className: 'flex items-center' },
						_react2.default.createElement(_caratIcon2.default, null)
					),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)('ml1', { 'black bold': label === _i18n2.default.t('dk-ui-lib.reports.scored') }) },
						score + ' ' + label
					)
				);
			}
		}, {
			key: 'renderCaratsDetails',
			value: function renderCaratsDetails() {
				var peerCarats = this.props.peerCarats;
				var _props2 = this.props,
				    carats = _props2.carats,
				    maxCarats = _props2.maxCarats;

				var _caratsScored = (0, _utils.padZero)(carats);
				var _totalCarats = (0, _utils.padZero)(maxCarats);
				var scoreLevels = [{ name: 'low', value: 35 * maxCarats / 100 }, { name: 'medium', value: 25 * maxCarats / 100 }, { name: 'high', value: 40 * maxCarats / 100 }];
				return _react2.default.createElement(
					'div',
					{ className: 'mt2 flex', style: { height: '9rem' } },
					_react2.default.createElement(
						'div',
						{ className: 'sm-col-4'
							// style={{marginTop: '3.2rem'}}
						},
						_react2.default.createElement(_SexyGauge2.default, {
							key: 'meter-carat-canvas',
							levels: scoreLevels,
							currentValue: carats,
							peerValue: peerCarats,
							totalValue: maxCarats,
							colors: { low: '#E5FD40', medium: '#80F38F', high: '#00DA7D' },
							icon: _react2.default.createElement(_meterCarat2.default, { className: 'svg-icon svg-3x' }),
							iconContainerClassName: 'meter-carat-icon',
							iconStyle: { left: '4.8rem', bottom: '6.3rem' },
							canvasId: 'meter-carat-canvas' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'sm-col-8 mt1 ml2' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'h4 field-name-primary' },
								_i18n2.default.t('dk-ui-lib.reports.carats')
							),
							_react2.default.createElement(
								'div',
								{ className: 'py2 px1 mt2 flex border justify-center rounded' },
								this.renderCaratScore(_caratsScored, _i18n2.default.t('dk-ui-lib.reports.scored')),
								_react2.default.createElement(
									'div',
									{ className: 'mx2' },
									'/'
								),
								this.renderCaratScore(_totalCarats, _i18n2.default.t('dk-ui-lib.reports.total'))
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'col-3 display-none' },
						_react2.default.createElement(
							'div',
							{ className: 'mt3' },
							_react2.default.createElement(
								'span',
								null,
								_i18n2.default.t('dk-ui-lib.reports.peer_avg')
							),
							_react2.default.createElement(
								'span',
								null,
								' ',
								peerCarats
							)
						)
					)
				);
			}
		}, {
			key: 'renderTimeDetails',
			value: function renderTimeDetails(startTime, endTime, totalTime) {

				var speedLevels = [{ name: 'low', value: 35 * totalTime / 100 }, { name: 'medium', value: 25 * totalTime / 100 }, { name: 'high', value: 40 * totalTime / 100 }];

				var timeTaken = Math.abs(startTime - endTime) / (60 * 60); // seconds to hours conversion

				return _react2.default.createElement(
					'div',
					{ className: 'clearfix flex', style: { height: '9rem' } },
					_react2.default.createElement(
						'div',
						{ className: 'sm-col-4'
							// style={{marginTop: '3.2rem'}}
						},
						_react2.default.createElement(_SexyGauge2.default, {
							key: 'meter-timer-canvas',
							levels: speedLevels,
							currentValue: timeTaken > totalTime ? totalTime : timeTaken.toFixed(2),
							peerValue: null,
							totalValue: totalTime,
							colors: { low: '#FFE1E2', medium: '#FF9B9E', high: '#FF0000' },
							icon: _react2.default.createElement(_Timer2.default, { className: 'svg-icon svg-3x' }),
							iconContainerClassName: 'meter-timer-icon',
							iconStyle: { left: '4.8rem', bottom: '6.7rem' },
							canvasId: 'meter-timer-canvas' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'sm-col-8 mt1 ml2' },
						_react2.default.createElement(
							'div',
							null,
							_react2.default.createElement(
								'div',
								{ className: 'h4 field-name-primary' },
								_i18n2.default.t('dk-ui-lib.reports.time_clocked')
							),
							_react2.default.createElement(
								'div',
								{ className: 'py2 px1 mt2 flex border justify-center rounded' },
								_react2.default.createElement(
									'div',
									{ className: 'bold black' },
									(0, _pluralize2.default)(_pluralize2.default.singular(_i18n2.default.t('dk-ui-lib.reports.hrs')), timeTaken.toFixed(2), true)
								),
								_react2.default.createElement(
									'div',
									{ className: 'mx2' },
									'/'
								),
								_react2.default.createElement(
									'div',
									null,
									(0, _pluralize2.default)(_pluralize2.default.singular(_i18n2.default.t('dk-ui-lib.reports.hrs')), totalTime, true)
								),
								_react2.default.createElement(
									'div',
									{ className: 'ml1' },
									_i18n2.default.t('dk-ui-lib.reports.total')
								)
							)
						)
					),
					_react2.default.createElement('div', { className: 'col-3 display-none' })
				);
			}
		}, {
			key: 'renderAssessmentDetails',
			value: function renderAssessmentDetails() {
				var _props3 = this.props,
				    _props3$assessment = _props3.assessment,
				    assessment = _props3$assessment === undefined ? {} : _props3$assessment,
				    startedAt = _props3.startedAt,
				    completedAt = _props3.completedAt;


				return _react2.default.createElement(
					'div',
					{ className: 'clearfix lg-px3 md-px2 sm-px2 px1 mt3 pb2' },
					_react2.default.createElement(
						'div',
						{ className: 'field-name-primary center' },
						_i18n2.default.t('dk-ui-lib.reports.assessment_taken')
					),
					_react2.default.createElement(
						'div',
						{ className: 'brand-color-dark extra-bold-black center mt2',
							style: { fontSize: '1.25rem' } },
						assessment.name.toUpperCase()
					),
					this.renderCaratsDetails(),
					this.renderTimeDetails(startedAt / 1000, completedAt / 1000, assessment.duration / 60)
				);
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					'div',
					null,
					this.renderTitleBar(),
					this.renderAssessmentDetails()
				);
			}
		}]);

		return SessionDetails;
	}(_react.Component);

	exports.default = SessionDetails;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/SessionDetails.js
// module id = 1181
// module chunks = 0